<template>
    <div >
      <highcharts :options="chartOptions" style="height: 600px; width: 90%; margin: auto;padding: 25px;"></highcharts>
    </div>
  </template>
  
  <script>
  import { Chart } from "highcharts-vue";
  import Highcharts from "highcharts-vue";
  
  export default {
    props: ["xaxis", "chartData", 'chartColors'],
    data() {
        return {
        chartOptions: {
            chart: {
                type: 'column',
                style:{
                    // direction: 'rtl',
                    // align: 'center'
                },
            },
                legend:{
                    rtl: true,
                },
            title: {
                text: '',
                
                useHTML: true, //bug fixed `IE9` and `EDGE`
                style: {
                    fontSize: '20px',
                    fontFamily: 'tahoma',
                    direction: 'rtl',
                },
            },
            xAxis: {
                categories: this.xaxis
            },
            yAxis: {
          min: 0, // Minimum value
          max: 100, // Maximum value
          tickInterval: 10, // Interval between ticks
                title: {
                    text: 'Some Details'
                },
                // categories: [`1`, `2`, `3`, `4`, `5`],
                labels: {
                    // Customize y-axis labels here
                    formatter: function() {
                    // You can format the labels using this function
                    return "(  " + this.value + ' %)'; // For example, append 'star' to each label
                    },
                    style: {
                        // You can customize the style of the labels here
                        color: 'red', // Change label text color
                        fontWeight: 'bold' // Make labels bold
                        // You can add more style properties as needed
                    }
                }
            },
            plotOptions: {
            column: {
                colorByPoint: false, // This allows each column to have its own color
                // colors: ['#FF0000', '#00FF00', '#0000FF'] // Specify colors for each column
                color: "#3f0e40",
                pointWidth: 30
            }
            },
            series: [{
                name: 'الطلبات ',
                data: this.chartData,
                colors: this.chartColors
            }]
        }
        };
    },
    watch:{
        chartData(val){
            
            // Update the chart data
            this.chartOptions.xAxis.categories = this.xaxis;
            this.chartOptions.series[0].data = this.chartData;
            this.chartOptions.series[0].colors = this.chartColors;
        }
    },
  
    components: {
      highcharts: Chart,
    },
  
    methods: {
        
    },
  
    created() {
    },
  };
  </script>
  